
export const environment = {
  production: false,
    API_BORYS_BACK: 'https://api-rys-recaudacion.apps.nbzapplications.com/api/v1',
    USER_KEY: '4d53bfadff690798e881d87e2f427b6d',
    APP_KEYCLOAK_URL: 'https://access.vnauth.com/auth',
    APP_KEYCLOAK_REALM: 'procesamiento',
    APP_KEYCLOAK_CLIENT_ID: '99247fce',
    defaultauth: 'firebase',
    firebaseConfig: {
      apiKey: 'AIzaSyBSNQDNzQLJLyJWnG40AO27_TY7gRkqjho',
      authDomain: 'test-authentication-4be35.firebaseapp.com',
      databaseURL: 'https://test-authentication-4be35.firebaseio.com',
      projectId: 'test-authentication-4be35',
      storageBucket: 'test-authentication-4be35.appspot.co',
      messagingSenderId: '679258537586',
      appId: '1:679258537586:web:00f41690d98a38435dcceb',
      measurementId: 'G-6L8TCTHC4H'
    },
    baseUrl: "http://localhost:3000/api/v1"
};
